import { render, staticRenderFns } from "./cashbankComponent.vue?vue&type=template&id=3837e3f3&scoped=true"
import script from "./cashbankComponent.vue?vue&type=script&lang=js"
export * from "./cashbankComponent.vue?vue&type=script&lang=js"
import style0 from "./cashbankComponent.vue?vue&type=style&index=0&id=3837e3f3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3837e3f3",
  null
  
)

export default component.exports